import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/softs/batchrename/iconFeature-5.png")